import { IProps } from "config/props";
import { chatPanel } from "./chat.panel";

const personalityMapping = {
  Generic: [chatPanel],
};

export const getPanel = ({ personality }: IProps) => {
  return personalityMapping[personality];
};
